import type { ReactNode } from 'react';
import { Link, type To } from 'react-router-dom';
import { buttonClassName, type ButtonAppearance, type ButtonSize, type ButtonVariant } from '../button/buttonClasses';

export interface ButtonLinkProps {
    /** Router destination. A navigation action always has one. */
    to: To;
    /** Router location state passed to the destination. */
    state?: unknown;
    /** Text only: it is the link's accessible name. Empty text warns outside production. */
    children: string;
    variant?: ButtonVariant;
    appearance?: ButtonAppearance;
    size?: ButtonSize;
    startIcon?: ReactNode;
    endIcon?: ReactNode;
    className?: string;
}

export function ButtonLink({ to, state, children, variant, appearance, size, startIcon, endIcon, className }: ButtonLinkProps) {
    if (process.env.NODE_ENV !== 'production' && children.trim() === '') {
        console.warn('[ButtonLink] `children` is empty, so the link has no accessible name. Pass visible text.');
    }

    return (
        <Link to={to} state={state} className={buttonClassName({ variant, appearance, size, className })}>
            {startIcon && <span className="flex items-center">{startIcon}</span>}
            {children}
            {endIcon && <span className="flex items-center">{endIcon}</span>}
        </Link>
    );
}
